// @flow
import React, { PureComponent } from 'react';

import TextInputMaterial from 'components/fragments/input/material/TextInputMaterial';
import CheckboxInput from 'components/fragments/input/CheckboxInput';
import Loading from 'components/fragments/Loading';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import { validateEmail } from 'utils/validatorUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';

import type { ContactFormType } from 'types/ContactForm';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';

export type StateProps = {
  contactForm: Array<ContactFormType>,
  sendStatus: Status,
  fetchStatus: Status
};

export type DispatchProps = {
  postContactForm: (formInputs: Object, id: number) => void,
  displayModal: (modalObject: string, content: Object, force: boolean) => void,
  fetchContactForm: () => void
};

type Props = {
  location: any,
  history: any,
  message?: string,
  content?: Array<BlocContent>
} & StateProps &
  DispatchProps;

type State = {
  prenom: string | null,
  nom: string | null,
  email: string | null,
  adresse: string | null,
  codePostal: string | null,
  ville: string | null,
  pays: string | null,
  consent1: boolean,
  consent2: boolean,
  consent3: boolean,
  message: string,
  error: string
};

class ContactFormJeuConcours extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    prenom: null,
    nom: null,
    email: null,
    adresse: null,
    codePostal: null,
    ville: null,
    pays: null,
    consent1: false,
    consent2: false,
    consent3: false,
    message: '',
    error: ''
  };

  componentDidMount = () => {
    const { fetchContactForm } = this.props;
    fetchContactForm();
  };

  _handleChange = (name: string, value: any) => {
    this.setState({ [name]: value });
  };

  setMessage = (e: any) => {
    const message = e.target.value;
    this.setState({ message });
  };

  isFormValid = () => {
    const { prenom, nom, email, adresse, codePostal, ville, pays, consent3 } = this.state;

    if (
      prenom === null ||
      prenom === '' ||
      nom === null ||
      nom === '' ||
      email === null ||
      !validateEmail(email) ||
      codePostal === null ||
      codePostal === '' ||
      adresse === null ||
      adresse === '' ||
      ville === null ||
      ville === '' ||
      pays === null ||
      pays === '' ||
      !consent3
    ) {
      return false;
    }

    return true;
  };

  handleSubmit = (e: MouseEvent) => {
    e.preventDefault();
    const { postContactForm, displayModal } = this.props;
    const { prenom, nom, email, adresse, codePostal, ville, pays, consent1, consent2, consent3 } = this.state;

    this.setState({ error: '' });

    if (!consent3) {
      displayModal(
        'MODAL_NEWSLETTER_MISSING_OPT',
        {
          text: `Pour participer au concours, merci d'accepter les conditions de la Fédération Française de Rugby`
        },
        true
      );
    } else {
      if (this.isFormValid()) {
        const formId = this._getFormId();

        const formData = {
          'jeu-concours-prenom': prenom ? prenom : '',
          'jeu-concours-nom': nom ? nom : '',
          'jeu-concours-email': email ? email : '',
          'jeu-concours-adresse': adresse ? adresse : '',
          'jeu-concours-code_postal': codePostal ? codePostal : '',
          'jeu-concours-ville': ville ? ville : '',
          'jeu-concours-pays': pays ? pays : '',
          'jeu-concours-consent1': consent1 ? consent1 : false,
          'jeu-concours-consent2': consent2 ? consent2 : false,
          'jeu-concours-consent3': consent3 ? consent3 : false,
          _wpcf7_unit_tag: formId
        };
        postContactForm(formData, formId);
      } else {
        this.setState({
          error: 'Veuillez vérifier le contenu du formulaire',
          prenom: prenom === null ? '' : prenom,
          nom: nom === null ? '' : nom,
          email: email === null ? '' : email,
          adresse: adresse === null ? '' : adresse,
          codePostal: codePostal === null ? '' : codePostal,
          ville: ville === null ? '' : ville,
          pays: pays === null ? '' : pays
        });
      }
    }
  };

  _getFormId = () => {
    const { contactForm } = this.props;

    if (contactForm && contactForm.length > 0) {
      const jeuConcoursForm = contactForm.filter(form => form.title === 'jeu-concours');

      if (jeuConcoursForm && jeuConcoursForm.length > 0) {
        return jeuConcoursForm[0].id;
      }
    }

    return 0;
  };

  _renderBlocContent = () => {
    const { content } = this.props;
    if (!content) return null;
    return content.map<any>((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  };

  render() {
    const { fetchStatus, sendStatus, message, content } = this.props;

    const { prenom, nom, email, adresse, codePostal, ville, pays, error } = this.state;

    const labels = {
      optin1: `J’autorise la FFR à transmettre certaines de mes données personnelles 
      (nom, prénom, e-mail, adresse postale) à des tiers, et notamment ses partenaires et fournisseurs officiels, 
      à des fins commerciales, associatives ou humanitaires.`,
      optin2: `J’autorise la FFR à utiliser mes données personnelles (e-mail, adresse postale) 
      à des fins promotionnelles ou commerciales pour ses propres activités 
      (billetterie, boutique officielle).`,
      optin3: `J’accepte le règlement du jeu-concours.
        <a href="https://api.www.ffr.fr/wp-content/uploads/2019/09/VINations2020.ReglementjeuconcoursVF.pdf" target="_blank" rel="external nofollow">Télécharger le règlement.</a>`
    };

    if (fetchStatus !== STATUS_SUCCESS) {
      return <Loading isWhite />;
    }

    if (sendStatus === STATUS_SUCCESS && fetchStatus === STATUS_SUCCESS) {
      return (
        <div className="mb-5 modal-content" style={{ boxShadow: 'none', textAlign: 'center' }}>
          <h3 className="mb-4">Participation au jeu concours</h3>
          <div className="modal__body modal__body--medium narrow-2">
            <div className="circle-icon circle-icon--check"></div>
            <span>Votre participation a bien été enregistrée.</span>
          </div>
        </div>
      );
    }

    const classNamesSend = dynamicClassName('btn btn--primary js-contact-send');
    sendStatus === STATUS_LOADING && classNamesSend.add('is-disabled');

    if (!this._getFormId()) {
      return (
        <div className="mb-5 modal-content" style={{ boxShadow: 'none', textAlign: 'center' }}>
          <div className="modal__body modal__body--medium narrow-2">
            <div className="circle-icon circle-icon--alert"></div>
            <span>{`Le jeu concours est terminé.`}</span>
          </div>
        </div>
      );
    }

    return (
      <form action="#">
        {message && <p className="mb-5">{message}</p>}
        <div className="form-row">
          <TextInputMaterial
            id="prenom"
            label="Votre prénom *"
            errorMessage="Ce champ est requis"
            hasError={prenom !== null && prenom.length === 0}
            onChange={(value: string) => this._handleChange('prenom', value)}
          />
          <TextInputMaterial
            id="nom"
            label="Votre nom *"
            errorMessage="Ce champ est requis"
            hasError={nom !== null && nom.length === 0}
            onChange={(value: string) => this._handleChange('nom', value)}
          />
        </div>
        <TextInputMaterial
          id="email"
          label="Adresse mail *"
          errorMessage={email === '' ? 'Ce champ est requis' : "Cet e-mail n'est pas valide"}
          hasError={email !== null && !validateEmail(email)}
          onChange={(value: string) => this._handleChange('email', value)}
        />
        <TextInputMaterial
          id="adresse"
          isLight
          label="Adresse *"
          errorMessage="Ce champ est requis"
          hasError={adresse !== null && adresse.length === 0}
          onChange={(value: string) => this._handleChange('adresse', value)}
        />
        <div className="form-row">
          <TextInputMaterial
            id="code_postal"
            label="Code postal *"
            errorMessage="Ce champ est requis"
            hasError={codePostal !== null && codePostal.length === 0}
            onChange={(value: string) => this._handleChange('codePostal', value)}
          />
          <TextInputMaterial
            id="ville"
            label="Ville *"
            errorMessage="Ce champ est requis"
            hasError={ville !== null && ville.length === 0}
            onChange={(value: string) => this._handleChange('ville', value)}
          />
        </div>
        <TextInputMaterial
          id="pays"
          label="Pays *"
          errorMessage="Ce champ est requis"
          hasError={pays !== null && pays.length === 0}
          onChange={(value: string) => this._handleChange('pays', value)}
        />
        <CheckboxInput
          className={'checkbox'}
          id="optin3"
          label={labels['optin3']}
          onChange={value => this._handleChange('consent3', value)}
        />
        <CheckboxInput
          className={'checkbox'}
          id="optin2"
          label={labels['optin2']}
          onChange={value => this._handleChange('consent2', value)}
        />
        <CheckboxInput
          className={'checkbox'}
          id="optin1"
          label={labels['optin1']}
          onChange={value => this._handleChange('consent1', value)}
        />
        <div className="form-action">
          <div>
            {error ? (
              <p>
                <span>{error}</span>
              </p>
            ) : (
              sendStatus === STATUS_SUCCESS && (
                <p>
                  <span style={{ color: '#4CB848', fontSize: '18px' }}>Votre participation a bien été envoyée</span>
                </p>
              )
            )}
            <p className="ft-tertiary">* champs obligatoires</p>
          </div>
          <div>
            <button className="btn btn--primary js-contact-send" type="button" onClick={this.handleSubmit}>
              Participer
            </button>
          </div>
        </div>
        {content && <div className="mb-5">{this._renderBlocContent()}</div>}
      </form>
    );
  }
}

export default ContactFormJeuConcours;
